import { lazy } from 'react';

const ListRoutes = [
    {
        path: '/industries/:slug',
        component: lazy(() => (
            import('../pages/fintech/Fintech')
        )),
    },
    {
        path: '/article/:slug',
        component: lazy(() => (
            import('../pages/article/article')
        )),
    },
    {
        path: '/works',
        component: lazy(() => (
            import('../pages/works/works')
        ))
    },
    {
        path: '/works/:slug/:Stack',
        component: lazy(() => (
            import('../pages/worksDetail/worksDetail')
        ))
    },
    {
        path: '/outsource',
        component: lazy(() => (
            import('../pages/outsource/landing/landing')
        ))
    },
    // {
    //     path: '/outsource/question/1',
    //     component: lazy(() => (
    //         import('../pages/outsource/Question/question1')
    //     ))
    // },
    // {
    //     path: '/outsource/question/2',
    //     component: lazy(() => (
    //         import('../pages/outsource/Question/question2')
    //     ))
    // },
    // {
    //     path: '/outsource/question/3',
    //     component: lazy(() => (
    //         import('../pages/outsource/Question/question3')
    //     ))
    // },
    // {
    //     path: '/outsource/question/4',
    //     component: lazy(() => (
    //         import('../pages/outsource/Question/question4')
    //     ))
    // },
    // {
    //     path: '/outsource/question/5',
    //     component: lazy(() => (
    //         import('../pages/outsource/Question/question5')
    //     ))
    // },
]

export { ListRoutes }